import React, { useEffect, useState } from 'react';
import { ServiceManifestDataForm } from '../../../../app/models/ServiceManifest';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { PaymentMethod } from '../../../../app/models/PaymentMethod';
import { Currency } from '../../../../app/models/Currency';
import { PaymentCondition } from '../../../../app/models/PaymentCondition';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { ExchangeRateDate } from '../../../../app/models/ExchangeRateDate';
import { ExchangeRateDateEnum } from '../../../../app/shared/enums';

interface Props {
    serviceManifestDataForm: ServiceManifestDataForm;
}

interface GeneralServiceManifestProps {
    serviceManifestDataForm: ServiceManifestDataForm;
    setServiceManifestDataForm: (serviceManifest: ServiceManifestDataForm) => void;
    // paymentMethods: PaymentMethod[];
    // currencies: Currency[];
    // paymentConditions: PaymentCondition[];
    exchangeRateDate: ExchangeRateDate[];
    isShow: boolean;
    errorFields?: any;
}

const ServiceManifestInvoicingForm = ({
    serviceManifestDataForm,
    setServiceManifestDataForm,
    // paymentMethods,
    // currencies,
    // paymentConditions,
    exchangeRateDate,
    errorFields,
    isShow = true,
}: GeneralServiceManifestProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors, errors } = useHandleErrorFields();
    const [showDeliveryMonthEndDateField, setShowDeliveryMonthEndDateField] = useState(false);
    const [showFixedDateField, setShowFixedDateField] = useState(false);


    useEffect(() => {
        setShowFixedDateField(serviceManifestDataForm.exchange_rate_date === ExchangeRateDateEnum.FECHA_FIJA);
    }, [serviceManifestDataForm.exchange_rate_date]);

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        setServiceManifestDataForm({ ...serviceManifestDataForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };

        if (name === 'society_id') {
            setErrors({
                ...errors,
                provider_id: '',
            });
        }

        setServiceManifestDataForm({ ...serviceManifestDataForm, ...obj });
    };

    if (!serviceManifestDataForm) return null;

    return (
        <>


                <div className="mb-2 row">
                    <div className="col-md-6">
                        <label className="col-form-label">
                        Forma de pago
                        </label>
                        <input
                            name="payment_method"
                            id="payment_method"
                            type="text"
                            className="form-control"
                            value={serviceManifestDataForm.payment_method ?? ''}
                            disabled={true}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="col-form-label">
                            Moneda
                        </label>
                        <input
                            name="currency"
                            id="currency"
                            type="text"
                            className="form-control"
                            value={serviceManifestDataForm.currency ?? ''}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="mb-2 row">
                <div className="col-md-6">
                    <label className="col-form-label">
                        Condición de pago
                    </label>
                    <input
                        name="payment_condition"
                        id="payment_condition"
                        type="text"
                        className="form-control"
                        value={serviceManifestDataForm.payment_condition ?? ''}
                        disabled={true}
                    />
                </div>
                <div className="col-md-6">
                    <label className="col-form-label">
                        Cantidad de días
                    </label>
                    <input
                        name="days_count"
                        id="days_count"
                        type="text"
                        className="form-control"
                        value={serviceManifestDataForm.days_count}
                        disabled={true}
                    />
                </div>
            </div>


            <div className="mb-2 row">
                <div className="col-md-6">
                    <label className="col-form-label">Fecha tipo de cambio</label>
                    <SelectTwo
                        name="exchange_rate_date"
                        id="exchange_rate_date"
                        inputValue={serviceManifestDataForm.exchange_rate_date}
                        options={SelectTwoMapperOptions(exchangeRateDate)}
                        hasError={fieldHasError('exchange_rate_date') !== ''}
                        onChange={(value: any) =>
                            handleChangeSelectTwo('exchange_rate_date', value.value)
                        }
                        onFocus={() => onFocusRemove('exchange_rate_date')}
                        disabled={true}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('exchange_rate_date')}
                    </div>
                </div>

            </div>

            {/* Fecha fija o lógica de fecha calculada */}
        {showFixedDateField ? (
            <div className="mb-2 row">
                <div className="col-md-6">
                <label className="col-form-label">Fecha fija</label>
                <input
                    type="date"
                    name="fixed_date"
                    className={`form-control ${fieldHasError('fixed_date')}`}
                    value={serviceManifestDataForm.fixed_date}
                    onChange={handleChange}
                    placeholder="Ingrese fecha"
                    onFocus={() => onFocusRemove('fixed_date')}
                    disabled={true}
                />
                <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('fixed_date')}
                </div>
                </div>
                {/* Valor tipo de cambio SIEMPRE visible */}
                <div className="col-md-6">
                <label className="col-form-label">Valor del tipo de cambio</label>
                <input
                    type="text"
                    name="final_rate"
                    className="form-control"
                    value={
                    serviceManifestDataForm.final_rate !== undefined &&
                    serviceManifestDataForm.final_rate !== null
                        ? serviceManifestDataForm.final_rate
                        : ''
                    }
                    disabled={true}
                />
                </div>
            </div>
            ) : (
            // Cuando NO es fecha fija: muestra fecha referencia + valor tipo de cambio
            <div className="mb-2 row">
                <div className="col-md-6">
                <label className="col-form-label">
                    Fecha de referencia para el tipo de cambio
                </label>
                <input
                    type="text"
                    name="exchange_rate_reference_date"
                    className="form-control"
                    value={
                    serviceManifestDataForm.exchange_rate_reference_date
                        ? serviceManifestDataForm.exchange_rate_reference_date
                        : ''
                    }
                    disabled={true}
                />
                </div>
                <div className="col-md-6">
                <label className="col-form-label">Valor del tipo de cambio</label>
                <input
                    type="text"
                    name="final_rate"
                    className="form-control"
                    value={
                    serviceManifestDataForm.final_rate !== undefined &&
                    serviceManifestDataForm.final_rate !== null
                        ? serviceManifestDataForm.final_rate
                        : ''
                    }
                    disabled={true}
                />
                </div>
            </div>
            )}
        </>
    );
};

export default ServiceManifestInvoicingForm;
